const commissionTiersById: any = {
  DO_NOT_USE: 1,
  PLATINUM: 2,
  GOLD: 3,
  SILVER: 4,
  BRONZE: 5,
  NOT_RECOMMENDED: 6,
  GOLD_PLUS: 7,
  DIAMOND: 8,
};

const commissionTierSortOrderById: number[] = [
  commissionTiersById.DIAMOND,
  commissionTiersById.PLATINUM,
  commissionTiersById.GOLD_PLUS,
  commissionTiersById.GOLD,
  commissionTiersById.SILVER,
  commissionTiersById.BRONZE,
  commissionTiersById.NOT_RECOMMENDED,
  commissionTiersById.DO_NOT_USE,
];

export { commissionTierSortOrderById, commissionTiersById };

export default {
  1: 'do not use',
  2: 'platinum',
  3: 'gold',
  4: 'silver',
  5: 'bronze',
  6: 'do not use',
  7: 'gold plus',
  8: 'diamond',
};
